// import ScrollMagic from 'scrollmagic';
// import { TweenMax, TimelineMax, Linear } from 'gsap';
// import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';

export default () => {
  if (!$('.editorial-promo').length) {
    return;
  }

  // ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
  
  const parallax_controller = new ScrollMagic.Controller(
    {
      globalSceneOptions: {
        triggerHook: 'onEnter',
        duration: '200%',
      },
    },
  );

  _.each($('.editorial-promo__illustration'), (parallax_element) => {
    const $trig = $(parallax_element).parent();
    
    new ScrollMagic.Scene({
      triggerElement: $trig.get(0),
    })
      .setTween(parallax_element, { y: '50%', ease: Linear.easeNone })
      .addTo(parallax_controller);
  });
};
